import axios from 'axios';
import { PLATFORM } from 'const';
const RUNTIME_API_BASE_URL_ANCHOR = '${API_BASE_URL}';
const RUNTIME_API_BASE_URL_ANCHOR_V2 = '${API_BASE_URL_V2}';
const isAnchorUnsubstituted = typeof RUNTIME_API_BASE_URL_ANCHOR === 'string' && /\$\{\s*API_BASE_URL\s*\}/.test(RUNTIME_API_BASE_URL_ANCHOR);
const isAnchorUnsubstitutedV2 = typeof RUNTIME_API_BASE_URL_ANCHOR_V2 === 'string' && /\$\{\s*API_BASE_URL_V2\s*\}/.test(RUNTIME_API_BASE_URL_ANCHOR_V2);
export const apiBaseUrl = isAnchorUnsubstituted ? 'http://localhost:3000' : RUNTIME_API_BASE_URL_ANCHOR;
export const apiBaseUrlV2 = isAnchorUnsubstitutedV2 ? 'http://localhost:3000' : RUNTIME_API_BASE_URL_ANCHOR_V2;
const request = axios.create({
    baseURL: `${apiBaseUrl}/api/v1`,
});
request.interceptors.response.use((response) => response, (error) => {
    if (error?.response?.status === 401 && window.location.pathname !== '/login') {
        window.location.href = '/login';
    }
    throw error;
});
export default request;
export const requestV2 = axios.create({
    baseURL: `${apiBaseUrlV2}/v2`,
});
const isAndroidApp = (ua) => /;\s*wv\)/i.test(ua);
const isIosApp = (ua) => /iPhone|iPad|iPod/i.test(ua) && !/Safari/i.test(ua);
const isMobileUa = (ua) => /Android|iPhone|iPad|iPod/i.test(ua);
// приложение — android, браузер на телефоне — web, компьютер — без заголовка
const getGmPlatform = () => {
    const ua = navigator.userAgent;
    if (isAndroidApp(ua) || isIosApp(ua))
        return 'android';
    if (PLATFORM === 'mobile' || isMobileUa(ua))
        return 'web';
    return null;
};
const applyGmPlatform = (config) => {
    const gmPlatform = getGmPlatform();
    if (gmPlatform)
        config.headers.set('X-GM-PLATFORM', gmPlatform);
    return config;
};
request.interceptors.request.use(applyGmPlatform);
requestV2.interceptors.request.use(applyGmPlatform);
requestV2.interceptors.request.use((config) => {
    const scope = config.headers?.['x-api-scope'] ?? config.headers?.['X-API-Scope'];
    const { baseURL } = config;
    if (scope === 'admin' && typeof baseURL === 'string' && baseURL.includes('api.')) {
        config.baseURL = baseURL.replace('api.', 'admin-api.');
    }
    return config;
});
requestV2.interceptors.response.use((response) => response, (error) => {
    if (error?.response?.status === 401 && window.location.pathname !== '/login') {
        window.location.href = '/login';
    }
    throw error;
});
export const setLanguage = (language) => {
    request.defaults.headers.common['Accept-Language'] = language;
    request.defaults.headers.common['X-API-Locale'] = language;
    requestV2.defaults.headers.common['Accept-Language'] = language;
    requestV2.defaults.headers.common['X-API-Locale'] = language;
};
export const setCountryCode = (country) => {
    request.defaults.headers.common['X-GM-COUNTRY'] = country;
    requestV2.defaults.headers.common['X-GM-COUNTRY'] = country;
};
export const setCurrencyHeader = (priceMeasurement) => {
    request.defaults.headers.common['X-GM-CURRENCY'] = priceMeasurement;
    requestV2.defaults.headers.common['X-GM-CURRENCY'] = priceMeasurement;
};
export const setMeasurementHeader = (squareMeasurement) => {
    request.defaults.headers.common['X-GM-MEASUREMENT'] = squareMeasurement;
    requestV2.defaults.headers.common['X-GM-MEASUREMENT'] = squareMeasurement;
};
export const setToken = (token) => {
    request.defaults.headers.common.Authorization = token;
    requestV2.defaults.headers.common.Authorization = token;
};
export const setLocalStorage = (key, value) => {
    localStorage.setItem(key, value);
};
